module.exports = __webpack_public_path__ + "static/media/money-bg.48e54196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/money-bg.jpg
// module id = 136
// module chunks = 0